import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import {i18n, vantLocales} from './i18n'

vantLocales(i18n.locale)//组件国际化

import 'video.js/dist/video-js.css'


//空降社区

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')
